<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.51367 4.63672C3.73099 2.9755 5.22747 2.26962 6.69336 2.88672C8.57003 3.65539 10.2538 4.69937 11.7178 6.04004C12.9682 7.17264 12.9975 8.78239 11.7178 9.95898C10.3318 11.2144 8.59936 12.3443 6.69336 13.1123C5.0716 13.7514 3.71311 12.9538 3.51367 11.3555C3.27101 8.99882 3.27636 6.74265 3.51367 4.63672Z"
      fill="#0A0A0A" />
  </svg>
</template>
